<template>
  <v-sheet
    id="signed-feedback"
    color="transparent"
    class="text-center px-10"
  >
    <img src="@/assets/signed-feedback-icon.svg">
    <h4 class="title text-h6 mt-12">
      {{ $t('signup.steps.SIG.feedback.title') }}
    </h4>
    <p 
      class="text text-body-1 my-8"
      v-html="formatText($t('signup.steps.SIG.feedback.subtitle'))"
    />
    <p 
      class="text text-body-1 my-8"
      v-html="formatText($t('signup.steps.SIG.feedback.text'))"
    />
  </v-sheet>
</template>

<style>

</style>

<script>

  // Icons
  import {
    mdiCheck,
  } from '@mdi/js'
  import services from '@/services.js'

  export default {
    name: 'SignerFeedback',

    data: () => ({
      icons: {
        mdiCheck,
      },
    }),
    methods: {
      ...services,
    }
  }
</script>
